const alertTypeEnum = {
	INFO: "info",
	WARNING: "warning",
	ERROR: "error",
	SUCCESS: "success",
};

export default alertTypeEnum;
